import React from "react";
import "./overview.css";
import Footer from "../Components_UBMeEvents/Footer/Footer";
import Navbar from "../Components_UBMeEvents/Navbar/Navbar";
import OverViewPricing from "./overviewPricing";
import Fade from "react-reveal/Fade";
import JotformEmbed from "react-jotform-embed";
import landingpage from "images/Website-Images/landingpage.png";
import flyers from "images/Website-Images/flyers.png";
import email from "images/Website-Images/email.png";
import analytics from "images/Website-Images/analytics.png";
import ticket from "images/Website-Images/ticket.png";
import engagement from "images/Website-Images/engagement.png";
import app from "images/Website-Images/app.png";
import ads from "images/Website-Images/ads.png";
import Grow from "images/Website-Images/Flourish.png";
import Audience from "images/Website-Images/audience.png";
import Experience from "images/Website-Images/experience.png";
import chat from "images/Website-Images/chat.png";
import satisfied from "images/Website-Images/satisfied.png";
import checkin from "images/Website-Images/checkin.png";
import analytics2 from "images/Website-Images/analytics2.png";
import howItWorks from "images/Website-Images/how_it_works.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from 'react-helmet';
import Modal from 'react-modal';
import YouTube from 'react-youtube';
import { useState, useEffect } from "react";

const Ipad = "https://www.ubme.com/wp-content/uploads/2023/04/Ipad-1536x1003.jpg";
const Iphones = "https://www.ubme.com/wp-content/uploads/2023/04/Iphones-1-2048x2005.jpg";
const Laptop = "https://www.ubme.com/wp-content/uploads/2023/04/Laptop3-2048x1521.jpg";

Modal.setAppElement('#root');

const OverView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const youtubeOpts = {
    height: '390',
    width: '640',
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const EngagementData = [
    {
      image: Grow,
      text: "Grow Your Event Business",
      text2:
        "Whether you run large or small events, UBMe includes advanced event management features for you to confidently organize and maintain all of your events in one place",
    },
    {
      image: Audience,
      text: "Build Your Event Audience",
      text2:
        "Promote your events easily and efficiently by using free built-in marketing tools, such as our customized event websites, email invitations, event fliers and more",
    },
    {
      image: Experience,
      text: "Create The Ultimate Experience",
      text2:
        "With the UBMe app, attendees are able to engage with one another in a live, digital experience for a more social environment and to connect easier with vendors and sponsors",
    },
  ];
  const businessData = [
    {
      img1: ticket,
      img2: app,
      text: "Complete online ticketing system with the ability to create discount codes to help you start selling tickets online as well as selling unlimited ticket types",
      text2:
        "Manage your events on-the-go and stay on top of event attendance and capacity by using the free UBMe Organizer app",
    },
    {
      img1: engagement,
      img2: ads,
      text: "Create engagements between attendees to spark interaction and communication to enhance their overall experience via the UBMe App            ",
      text2:
        "Create rotating in-app ads for all of your attendees to see in order to attract advertisers and generate additional revenue",
    },
  ];
  const audienceData = [
    {
      img1: landingpage,
      img2: email,
      text: "Build an eye-catching, customized event website to sell tickets online; includes FAQs, agendas, sponsor info, vendor info, event maps and more",
      text2:
        "Utilize your existing email lists and our free email marketing database to upload up to 2,000 contacts and send up to 8,000 free event invitations each month",
    },
    {
      img1: flyers,
      img2: analytics,
      text: "Access to auto-generated event flyers that can be dowloaded for use of social media & digital marketing or for printing of physical copies",
      text2:
        "Capture attendee info during each event and export analytics after your event concludes to help grow your social media, email contacts and future events overall",
    },
  ];
  const experienceData = [
    {
      img1: chat,
      img2: checkin,
      text: "UBMe creates a real-time network at your events to keep you connected with your attendees and to spark a more social and engaged event environment",
      text2:
        "Attract advertisers and gain additional revenue by creating in-app ads for all of your attendees to see",
    },
    {
      img1: satisfied,
      img2: analytics2,
      text: "Only people located on-site can ‘check-in’ to access your event's Live Chat, meaning that only the attendees who are physically attending your event can be in on the fun",
      text2:
        "Deliver more results and provide additional exposure for vendors & sponsors through UBMe's post-event reports",
    },
  ];

  const shouldRenderTag = true;

  return (
      <>
        <Helmet>
          {shouldRenderTag && (
              <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11228957629"></script>
          )}
          {shouldRenderTag && (
              <script>
                {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-11228957629');
            `}
              </script>
              )}
        </Helmet>
      <div>
      <Navbar />
      <div className="overview-container">
        <div className="overview-wrapper">
          <div className="overview-container-text">
            <Fade bottom>
              <h1>Make Your Events More Engaging!</h1>
            </Fade>
            <Fade bottom>
              <p>
                Create your event on UBMe and provide a better experience for
                your attendees!
              </p>
            </Fade>
            <Fade bottom>
              <div>
                <button onClick={openModal} style={{background: "none", border:"none"}} className="how-it-works-button">
                  <img src={howItWorks}/>
                </button>
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="Screen-size Popup"
                    style={{
                      overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                    }}
                    className="youtube-modal"
                >
                  <button onClick={closeModal} className="close-button">
                    X
                  </button>

                  <div className="youtube-video">
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/mgZKDp68Dqw"
                        title="YouTube Video"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>
                  </div>
                </Modal>
              </div>
            </Fade>
          </div>

          <JotformEmbed
            className="jot_form_2"
            src="https://form.jotform.com/203031208199146"
          />
        </div>
      </div>
      <div className="overview-about-wrapper">
        <div className="overview-about-content">
          <Fade bottom>
            <h1>About UBMe</h1>
          </Fade>
          <Fade bottom>
            <p>
              UBMe takes your events to the next level by creating a more
              engaging, social environment and providing a unique experience to
              only those who are physically attending your event. You can create
              a free, customized website for ticket sales and promote your event
              with free marketing tools all within the UBMe Organizer
              Portal. Once your event begins, your attendees can check-in with
              the free UBMe app to share the experiences happening at the event
              as well as joining other real-time, digital engagements. During
              your events, you have full control over the UBMe app to stay
              connected with your attendees through real-time updates &
              announcements, participation boosts, survey/poll send-outs and so
              much more! Once the event concludes, you will have access to high
              quality event analytics, as well as a complete attendee engagement
              breakdown that provides insights to help grow and shape your
              future events.
            </p>{" "}
          </Fade>
          <Fade bottom>
            <h5>
              Get started today by signing-up for a free account and create your
              first event in minutes!
            </h5>
          </Fade>
        </div>
      </div>
      <div className="overview-container-box">
        <div className="overview-card-container">
          <div className="overview-card-text">
            <Fade bottom>
              <h1>Advanced Event Management and Engagement Software</h1>
            </Fade>
          </div>
          <div className="overview-card-wrapper">
            {EngagementData.map(({ image, text, text2 }) => (
              <Fade bottom>
                <div className="overview-card">
                  <figure>
                    <LazyLoadImage
                      src={image}
                      //  width={"100%"}
                      //  height={"100%"}
                      PlaceholderSrc={"PlaceholderImage"}
                      effect="blur"
                    />
                  </figure>
                  <div>
                    <h4>{text}</h4>
                    <p>{text2}</p>
                  </div>
                </div>
              </Fade>
            ))}
          </div>
        </div>
      </div>
      <OverViewPricing />

      <div className="overview-business-container">
        <div className="overview-business">
          <div className="overview-business-text">
            <Fade bottom>
              <h2>Grow Your Event Business</h2>
            </Fade>
            <Fade bottom>
              <p>
                Our advanced event management features give you the tools to
                confidently organize and maintain all of your events, whether
                they are large or small. Create events and sell tickets to your
                local community, manage the attendee experience at you events in
                real-time and provide more exposure for your vendors & sponsors
                to grow your event business.
              </p>
            </Fade>
          </div>
          <div className="overview-business-cards">
            {businessData.map(({ img1, img2, text, text2 }) => (
              <div className="overview-business-card-text">
                <Fade bottom>
                  <div className="overview-business-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img1}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text}</p>
                  </div>
                </Fade>
                <Fade bottom>
                  <div className="overview-business-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img2}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text2}</p>
                  </div>
                </Fade>
              </div>
            ))}

            <Fade bottom>
              <div className="overview-business-card-image">
                <figure>
                  <LazyLoadImage
                    src={Iphones}
                    //  width={"100%"}
                    //  height={"100%"}
                    PlaceholderSrc={"PlaceholderImage"}
                    effect="blur"
                  />
                </figure>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      <div className="overview-audience-container">
        <div className="overview-audience">
          <div className="overview-audience-text">
            <Fade bottom>
              <h2>Build Your Event Audience</h2>
            </Fade>
            <Fade bottom>
              <p>
                UBMe helps you build your local event audience with tools to
                grow your email marketing list and attract new potential
                attendees. Promote your events easily and efficiently by using
                free built-in marketing tools, such as our customized event
                websites, email invitations, event fliers and more!
              </p>
            </Fade>
          </div>
          <div className="overview-audience-cards">
            <div className="overview-audience-card-image">
              <figure>
                <LazyLoadImage
                  src={Laptop}
                  //  width={"100%"}
                  //  height={"100%"}
                  PlaceholderSrc={"PlaceholderImage"}
                  effect="blur"
                />
              </figure>
            </div>
            {audienceData.map(({ img1, img2, text, text2 }) => (
              <div className="overview-audience-card-text">
                <Fade bottom>
                  <div className="overview-audience-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img1}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text}</p>
                  </div>
                </Fade>
                <Fade bottom>
                  <div className="overview-audience-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img2}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text2}</p>
                  </div>
                </Fade>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="overview-experience-container">
        <div className="overview-experience">
          <div className="overview-experience-text">
            <Fade bottom>
              <h2>Create The Ultimate Experience</h2>
            </Fade>
            <Fade bottom>
              <p>
                The free UBMe app is designed to create the ultimate, in-person
                experience at your events by providing additional connectivity
                and engagement between attendees, leading to more meaningful
                interactions and experiences at your event. Using the UBMe app
                at your events will help you boost the engagement at your events
                and provide a way for your vendors & sponsors to connect with
                attendees in a more productive way.{" "}
              </p>
            </Fade>
          </div>
          <div className="overview-experience-cards">
            {experienceData.map(({ img1, img2, text, text2 }) => (
              <div className="overview-experience-card-text">
                <Fade bottom>
                  <div className="overview-experience-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img1}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text}</p>
                  </div>
                </Fade>
                <Fade bottom>
                  <div className="overview-experience-card-box">
                    <figure>
                      <LazyLoadImage
                        src={img2}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />
                    </figure>
                    <p>{text2}</p>
                  </div>
                </Fade>
              </div>
            ))}
            <Fade bottom>
              <div className="overview-experience-card-image">
                <figure>
                <LazyLoadImage
                        src={Ipad}
                        //  width={"100%"}
                        //  height={"100%"}
                        PlaceholderSrc={"PlaceholderImage"}
                        effect="blur"
                      />

                </figure>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <Footer />
    </div>
        </>
  );
};

export default OverView;
